import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../../api/errors/api-error-codes';

export const createCrmBillOperation = async (
  accountId: number,
  payload: {
    branchId: number | null;
    amount: number;
    services: { serviceName: string; unitPrice: number; units: number }[];
    recipientName?: string;
    issuedFor?: string;
    note?: string;
  },
  setLoading: (loading: boolean) => any,
  onSuccess: () => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.createCrmBill(accountId, {
      branchId: payload.branchId,
      amount: payload.amount,
      services: payload.services,
      ...(payload.recipientName != null && String(payload.recipientName).trim()
        ? { recipientName: String(payload.recipientName).trim() }
        : {}),
      ...(payload.issuedFor != null && String(payload.issuedFor).trim()
        ? { issuedFor: String(payload.issuedFor).trim() }
        : {}),
      ...(payload.note != null && String(payload.note).trim()
        ? { note: String(payload.note).trim() }
        : {}),
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    toast.success('החשבונית נוצרה בהצלחה');
    setLoading(false);
    onSuccess();
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
